'use client';

import cn from 'classnames';
import moment from 'moment';
import { useToggle } from 'react-use';
import { Button } from '@petsmart-ui/sparky';
import { PreviewDrawer } from '../PreviewDrawer';
import type { PreviewProps } from './types';
import './Preview.scss';

export function Preview({ previewDate }: PreviewProps) {
    const [isOpen, toggle] = useToggle(false);

    return (
        <>
            <Button
                onClick={toggle}
                variant="primary"
                iconName="clock-outline"
                text={previewDate ? moment(previewDate).format('MMM D') : ''}
                className={cn('site-preview-btn', {
                    'site-preview-btn__outline': !previewDate,
                })}
            />

            <PreviewDrawer isOpen={isOpen} previewDate={previewDate} onClose={toggle} />
        </>
    );
}
